<template>
  <div id="navIndexWrapper" class="navIndexWrapper">
    <div class="mainParentContainer">
      <nuxt-link class="navLogo" to="/">
        <img src="/media/Logo.svg" />
        <div v-if="screenWidth < 768 || screenWidth >= 1024">Groover</div>
      </nuxt-link>
      <div v-if="screenWidth >= 768" class="flexIt">
        <switch_lang v-if="!is_logged_in || is_signup" />
        <transition v-if="!is_signup" name="fade">
          <nav_logged_in v-if="is_logged_in && !IS_UNVALID_BAND" />
          <nav_logged_out v-else />
        </transition>
      </div>
      <nav_mobile v-else />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex"

import nav_mobile from "~/components/nav/mobile"
import nav_logged_in from "~/components/nav/loggedIn"
import nav_logged_out from "~/components/nav/loggedOut"
import switch_lang from "~/components/nav/switchLang"

import resize_mixin from "~/mixins/resize"

export default {
  components: {
    nav_mobile,
    switch_lang,
    nav_logged_in,
    nav_logged_out,
  },
  mixins: [resize_mixin],
  mounted: function () {
    if (this.$route.query.fs && this.user.is_facebook === false)
      this.displaySignupConfirm = true
  },
  computed: {
    is_signup: function () {
      return this.$route.path.includes("/signup/")
    },
    ...mapGetters({
      is_logged_in: "user/IS_LOGGED_IN",
      IS_UNVALID_BAND: "user/IS_UNVALID_BAND",
    }),
    ...mapState({
      user: (state) => state.user,
      display_signup: (state) => state.band_signup.display,
      display_login: (state) => state.login.display,
    }),
  },
}
</script>
<style scoped>
.navIndexWrapper.navNoShadow {
  box-shadow: unset;
}
.navIndexWrapper {
  width: 100%;
  position: relative;
  background-color: var(--color-white);
  box-shadow: var(--shadow-regular);
  z-index: 10001;
}

.mainParentContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0px;
  z-index: 90;
}

.navLogo {
  display: flex;
  align-items: center;
}

.navLogo > img {
  height: 24px;
  width: 24px;
  object-position: center;
  object-fit: contain;
  margin-right: 4px;
}

.navLogo > div {
  font-size: var(--font-size-title-micro);
  color: var(--color-main);
  font-family: EuclidFlex;
  font-weight: 700;
}

.flexIt {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.flexIt > * {
  margin-right: 32px;
}

.flexIt > *:last-child {
  margin-right: 0px;
}

.navIndexWrapper * {
  font-size: var(--font-size);
}

@media screen and (min-width: 768px) {
  .navLogo > img {
    height: 32px;
    width: 32px;
  }
}

@media screen and (min-width: 1024px) {
  .flexIt > * {
    margin-right: 48px;
  }
}
</style>
